import { AbstractControl, ValidatorFn } from '@angular/forms';
import { EmailValidationErrors } from '@shared/validation/validation-errors.model';
import { RegexPatterns } from '@shared/validation/validation-patterns.const';
import { isEmpty } from 'lodash';

export const emailAddressValidator =
  (): ValidatorFn =>
  (control: AbstractControl): EmailValidationErrors | null =>
    validateEmailAddress(control?.value);

export const validateEmailAddress = (emailValue: string): EmailValidationErrors | null => {
  if (isEmpty(emailValue)) {
    return null;
  }

  const umlautRegex = new RegExp('[äöüëïöüÿÄÖÜËÏÖÜŸ]+');

  if (umlautRegex.test(emailValue)) {
    return { umlautCharacter: true };
  }

  const invalidEmailAddressError = { invalidEmailAddress: true };

  const emailRegex = new RegExp(RegexPatterns.email);

  if (!emailRegex.test(emailValue)) {
    return invalidEmailAddressError;
  }

  const emailCannotContainRegex = new RegExp('[ßæ¥þ‰¼><=]+');

  if (emailCannotContainRegex.test(emailValue)) {
    return invalidEmailAddressError;
  }

  const nonAsciiCharsRegex = new RegExp('[^\x00-\x7F]+');

  if (nonAsciiCharsRegex.test(emailValue)) {
    return invalidEmailAddressError;
  }

  return null;
};
